// @ts-nocheck
import ProductDetailsState from "@store/Framework/Store/Bunzl/Pages/ProductDetails/ProductDetailsState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import {
    ProductDetailsCanScrollNextParameter,
    ProductDetailsCanScrollPrevParameter,
} from "@store/Framework/Store/Bunzl/Pages/ProductDetails/ProductDetailsTypes";
import { Draft } from "immer";

const initialState: ProductDetailsState = {
    canScrollNext: false,
    canScrollPrev: false,
};

const actions = {
    "Store/Pages/ProductDetails/CanScrollNext": (
        draft: Draft<ProductDetailsState>,
        action: { parameter: ProductDetailsCanScrollNextParameter },
    ) => {
        draft.canScrollNext = action.parameter;
    },
    "Store/Pages/ProductDetails/CanScrollPrev": (
        draft: Draft<ProductDetailsState>,
        action: { parameter: ProductDetailsCanScrollPrevParameter },
    ) => {
        draft.canScrollPrev = action.parameter;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type BunzlPagesProductDetailsActions = Parameters<typeof reducer>[1];
export default reducer;
